'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _Sizes = require('./Sizes');

var _Sizes2 = _interopRequireDefault(_Sizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_Component) {
  _inherits(Row, _Component);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          column = _props.column,
          doubling = _props.doubling,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['column', 'doubling', 'className']);

      var cx = (0, _classnames2.default)(column ? _Sizes2.default[column - 1] + ' column' : null, {
        doubling: doubling
      }, 'row', className);

      return _react2.default.createElement(_Box2.default, _extends({
        className: cx
      }, rest));
    }
  }]);

  return Row;
}(_react.Component);

Row.displayName = 'Row';

Row.propTypes = {
  column: _propTypes2.default.number,
  doubling: _propTypes2.default.bool
};

exports.default = Row;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6WyJSb3ciLCJwcm9wcyIsImNvbHVtbiIsImRvdWJsaW5nIiwiY2xhc3NOYW1lIiwicmVzdCIsImN4IiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJudW1iZXIiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsRzs7Ozs7Ozs7Ozs7NkJBQ0s7QUFBQSxtQkFNSCxLQUFLQyxLQU5GO0FBQUEsVUFFTEMsTUFGSyxVQUVMQSxNQUZLO0FBQUEsVUFHTEMsUUFISyxVQUdMQSxRQUhLO0FBQUEsVUFJTEMsU0FKSyxVQUlMQSxTQUpLO0FBQUEsVUFLRkMsSUFMRTs7QUFPUCxVQUFJQyxLQUFLLDBCQUNQSixTQUFZLGdCQUFNQSxTQUFTLENBQWYsQ0FBWixlQUF5QyxJQURsQyxFQUVQO0FBQ0VDO0FBREYsT0FGTyxFQUtQLEtBTE8sRUFNUEMsU0FOTyxDQUFUOztBQVNBLGFBQ0U7QUFDRSxtQkFBV0U7QUFEYixTQUVNRCxJQUZOLEVBREY7QUFNRDs7Ozs7O0FBR0hMLElBQUlPLFdBQUosR0FBa0IsS0FBbEI7O0FBRUFQLElBQUlRLFNBQUosR0FBZ0I7QUFDZE4sVUFBUSxvQkFBVU8sTUFESjtBQUVkTixZQUFVLG9CQUFVTztBQUZOLENBQWhCOztrQkFLZVYsRyIsImZpbGUiOiJSb3cuanMiLCJzb3VyY2VSb290IjoiRDpcXFByb2plY3RzXFxyZWFjdC10b2Nhc1xcc3JjIn0=



//////////////////
// WEBPACK FOOTER
// ../lib/Row.js
// module id = 572
// module chunks = 0